import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'

/** TRANSLATION*/
import { useTranslation } from 'react-i18next'

/** API */

/** UTILS || SLICE */
import { submitModal } from 'app/slice/modal.slice'
import { isCreate, isDelete, isUpdate, isView } from 'utils/verification.utils'

/** COMPONENT */
import { faSearch, faTimes } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import AddCircleIcon from '@mui/icons-material/AddCircle'
import { Box, Grid, InputAdornment, Typography } from '@mui/material'
import ProductWarningsApi from 'api/setting/default-products/product-warning.api'
import HeaderCard from 'component/CardCustom/HeaderCard'
import { notiError, notiSuccess } from 'component/notifications/notifications'
import TableRowExport from 'component/Pdf/TableRowExport'
import TableCustom from 'component/Table/TableCustom'
import TableRowCommon from 'component/Table/TableRowCommon'
import MainButton from 'new-components/buttons/main-button'
import SwitchButton from 'new-components/buttons/switch-button'
import SelectInput from 'new-components/inputs/select-input'
import TextInput from 'new-components/inputs/text-input'
import AlertModal from 'new-components/modal/alert-modal'
import PageModal from 'new-components/modal/page-modal'
import SnackbarComponent from 'new-components/snackbar/snackbar-component'

const permissions = {
    isCreate: isCreate(),
    isDelete: isDelete(),
    isUpdate: isUpdate(),
    isView: isView()
}

const initStateErrorMessage = {
    PRODUCT_WARNING_NAME: ``,
    IS_DUPLICATE_PRODUCT_WARNING_NAME: ``,
    PRODUCT_WARNING_NAME_STRING_BASE: ``,
    PRODUCT_WARNING_NAME_STRING_EMPTY: ``,
    PRODUCT_WARNING_NAME_MAXIMUM_LENGTH: ``,
    PRODUCT_WARNING_NAME_ANY_REQUIRED: ``,

    PRODUCT_WARNING_NAME_EN: ``,
    IS_DUPLICATE_PRODUCT_WARNING_NAME_EN: ``,
    PRODUCT_WARNING_NAME_EN_STRING_BASE: ``,
    PRODUCT_WARNING_NAME_EN_STRING_EMPTY: ``,
    PRODUCT_WARNING_NAME_EN_MAXIMUM_LENGTH: ``,
    PRODUCT_WARNING_NAME_EN_ANY_REQUIRED: ``
}
export default function MedicineWarnings() {
    const { t } = useTranslation()
    const dispatch = useDispatch()

    const [productWarnigs, setProductWarnigs] = useState([])
    const [productWarnigId, setProductWarnigId] = useState(Number)
    const [productWarnigName, setProductWarnigName] = useState('')
    const [productWarnigNameEn, setProductWarnigNameEn] = useState('')
    const [productWarnigStatus, setProductWarnigStatus] = useState('')
    const [errorMessage, setErrorMessage] = useState(initStateErrorMessage)
    const [textLength, setTextLength] = useState<number>(0)
    const [textLengthEn, setTextLengthEn] = useState<number>(0)
    const [errorName, setErrorName] = useState<any>()
    const [errorMaxLength, setErrorMaxLength] = useState<boolean>(false)


    /** PAGINATION  */
    const [page, setPage] = useState(1)
    const [pageLimit, setPageLimit] = useState(10)
    const [rowCount, setRowCount] = useState(0)
    const [sortBy, setSortBy] = useState('createAt')
    const [sortType, setSortType] = useState('ASC')
    const [search, setSearch] = useState('')
    const [status, setStatus] = useState('ALL')
    const [disabledSubmit, setDisabledSubmit] = useState(false)
    const [isOpenAlertModal, setIsOpenAlertModal] = useState(false)
    const [statusAlertModal, setStatusAlertModal] = useState('')
    const [id, setId] = useState<number>(0)
    const [name, setName] = useState('')
    const [nameEn, setNameEn] = useState('')
    const [isOpenSnack, setIsOpenSnack] = useState(false)
    const [typeSnack, setTypeSnack] = useState<any>("success")
    const [labelSnack, setLabelSnack] = useState('')

    const [isOpenPageModal, setIsOpenPageModal] = useState(false)


    const loadData = async () => {
        try {
            const resp = await ProductWarningsApi.getProductWarning({
                page: page,
                pageLimit: pageLimit,
                search: search,
                sortBy: sortBy,
                sortType: sortType,
                status: status === 'ALL' ? '' : status
            })
            if (resp.status === 200) {
                setRowCount(resp.headers['x-total'])
                setProductWarnigs(resp.data)
            } else {
                setProductWarnigs([])
            }
        } catch (error) {
            notiError('ERROR')
        }
    }

    useEffect(() => {
        loadData()
    }, [page, pageLimit, sortBy, sortType])

    const submit = () => {
        if (!productWarnigName) return setErrorMessage({ ...errorMessage, ...{ PRODUCT_WARNING_NAME: t('MEDICINE_WARNING.MESSAGE.PRODUCT_WARNING_NAME') } })

        dispatch(submitModal())
        setDisabledSubmit(true)
        ProductWarningsApi.postCreateProductWarning({ group: "MEDICINE", productWarningName: productWarnigName, productWarningNameEn: productWarnigNameEn })
            .then((res: any) => {
                if (res.status !== undefined && res.status === 201) {
                    notiSuccess(t('MEDICINE_WARNING.MESSAGE.SUCCESS.CREATE'), '', null, null)
                    resetForm()
                    loadData()
                    setIsOpenPageModal(false)
                } else {
                    const err = res.response.data
                    setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`MEDICINE_WARNING.MESSAGE.${err.message}`) } })
                }
            })
            .catch((e: any) => {
                const err = e.response.data
                setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`MEDICINE_WARNING.MESSAGE.${err.message}`) } })
            }).finally(() => setDisabledSubmit(false))
    }

    const submitEdit = () => {
        if (!productWarnigName) return setErrorMessage({ ...errorMessage, ...{ PRODUCT_WARNING_NAME: t(`MEDICINE_WARNING.MESSAGE.PRODUCT_WARNING_NAME`) } })
        dispatch(submitModal())
        setDisabledSubmit(true)
        ProductWarningsApi.patchUpdateProductWarning(productWarnigId, { group: "MEDICINE", status: productWarnigStatus ? 'ACTIVE' : 'INACTIVE', productWarningName: productWarnigName, productWarningNameEn: productWarnigNameEn }).then((res: any) => {
            if (res.status !== undefined && res.status === 200) {
                notiSuccess(t(`MEDICINE_WARNING.MESSAGE.SUCCESS.UPDATE`), '', null, null)
                resetForm()
                loadData()
                setIsOpenPageModal(false)
            } else {
                const err = res.response.data
                setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`MEDICINE_WARNING.MESSAGE.${err.message}`) } })
            }
        })
            .catch((e: any) => {
                const err = e.response.data
                setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`MEDICINE_WARNING.MESSAGE.${err.message}`) } })
            }).finally(() => setDisabledSubmit(false))
    }

    const clearErrorMessage = () => {
        setErrorMessage(initStateErrorMessage)
    }

    const handleChangeName = (e: any) => {
        setErrorName('')
        const name = e === '' ? '' : String(e)
        const contentLength = name.length

        if (contentLength > 40) {
            setErrorMaxLength(true)
        } else {
            setProductWarnigName(name)
            setTextLength(contentLength)
            setErrorMaxLength(false)
        }

    }
    const handleChangeNameEn = (e: any) => {
        const nameEn = e === '' ? '' : String(e)
        const contentLength = nameEn.length
        if (contentLength > 40) {
            setErrorMaxLength(true)
        } else {
            setProductWarnigNameEn(nameEn)
            setTextLengthEn(contentLength)
            setErrorMaxLength(false)
        }

    }

    const resetForm = () => {
        setProductWarnigId(0)
        setProductWarnigName('')
        setProductWarnigNameEn('')
        setProductWarnigStatus('')
        clearErrorMessage()
        setIsOpenPageModal(false)
        setTextLength(0)
        setErrorMaxLength(false)
        setTextLengthEn(0)
    }

    const onActive = () => {
        if (id) {
            ProductWarningsApi.patchUpdateStatusProductWarning(id, { status: statusAlertModal }).then((resp) => {
                if (resp.status === 200) {
                    setIsOpenAlertModal(false)
                    setIsOpenSnack(true)
                    setTypeSnack("success")
                    setLabelSnack(t('MEDICINE_WARNING.MESSAGE.SUCCESS.UPDATE_STATUS'))
                    loadData()
                } else {
                    setIsOpenAlertModal(false)
                    setIsOpenSnack(true)
                    setTypeSnack("error")
                    setLabelSnack(t('MEDICINE_WARNING.MESSAGE.ERROR'))
                }
            })
        }
    }
    const onDelete = () => {
        if (id) {
            ProductWarningsApi.deleteProductWarning(id).then((resp) => {
                if (resp.status === 200) {
                    setIsOpenAlertModal(false)
                    setIsOpenSnack(true)
                    setTypeSnack("success")
                    setLabelSnack(t('MEDICINE_WARNING.MESSAGE.SUCCESS.DELETE'))
                    loadData()
                } else {
                    setIsOpenAlertModal(false)
                    setIsOpenSnack(true)
                    setTypeSnack("error")
                    setLabelSnack(t('MEDICINE_WARNING.MESSAGE.ERROR'))
                }
            })
        }
    }

    const onEdit = (data: any) => {
        const { productWarningId: pdWarningId, productWarningName: pdWarningName, productWarningNameEn: pdWarningNameEn, status: pdWarningStatus } = data
        setProductWarnigId(pdWarningId)
        setProductWarnigName(pdWarningName)
        setProductWarnigNameEn(pdWarningNameEn)
        setProductWarnigStatus(pdWarningStatus)
        setIsOpenPageModal(true)
        handleChangeNameEn(pdWarningNameEn)
        handleChangeName(pdWarningName)
    }

    const onRequestSort = (sortByVal: string, sortTypeVal: string) => {
        setSortType(sortTypeVal)
        setSortBy(sortByVal)
    }

    const handleChangePage = (val: number) => {
        setPage(val)
    }

    const handleChangeRowsPerPage = (limit: number) => {
        setPageLimit(limit)
    }
    const handleChangeStatus = (statusVal: string) => {
        setStatus(statusVal)
    }
    const headCells = [
        { id: 'no', disablePadding: false, label: '#', width: '50px', align: 'center', },
        { id: 'productWarningName', disablePadding: false, label: t('MEDICINE_WARNING.TABLE.CELL.PRODUCT_WARNING_NAME'), align: 'left', },
        { id: 'productWarningNameEn', disablePadding: false, label: t('MEDICINE_WARNING.TABLE.CELL.PRODUCT_WARNING_NAME_EN'), align: 'left', },
        { id: 'status', disablePadding: false, label: t('MEDICINE_WARNING.TABLE.CELL.STATUS'), align: 'center', width: '150px' },
        { id: 'updatedBy', disablePadding: false, label: t('MEDICINE_WARNING.TABLE.CELL.UPDATED_BY'), align: 'center', width: '180px' },
        { id: 'action', disablePadding: false, label: 'Action', width: '80px' }
    ]

    const renderData = (objData: any, index: number, isExport?: boolean) => {
        if (isExport) {
            index = index + 1
        } else {
            index = page * pageLimit - pageLimit + index + 1
        }

        const { productWarningId, productWarningName, productWarningNameEn, updatedBy, updatedAt, status } = objData

        const objRenderData = {
            key: productWarningId,
            id: productWarningId,
            obj: objData,
            columns: [
                { option: 'TEXT', align: 'center', label: index },
                { option: 'TEXT', align: 'left', label: productWarningName || '' },
                { option: 'TEXT', align: 'left', label: productWarningNameEn || '' },
                { option: 'STATUS', align: 'center', label: status },
                { option: 'UPDATE_BY', align: 'center', label: { updatedBy: updatedBy || '-', updatedAt: updatedAt ?? '10/12/2564 08.59' } },
                {
                    option: 'ACTION',
                    align: 'center',
                    label: 'action',
                    values: [
                        { option: 'STATUS_ACTIVE', label: t(`STATUS.ACTIVE`), disabled: status === 'ACTIVE' },
                        { option: 'STATUS_INACTIVE', label: t(`STATUS.INACTIVE`), disabled: status === 'INACTIVE' },
                        { option: 'DIVIDER', label: '', disabled: false },
                        { option: 'EDIT', label: t(`BUTTON.EDIT`), disabled: permissions.isUpdate.disabled },
                        { option: 'DELETE', label: t(`BUTTON.DELETE`), disabled: permissions.isDelete.disabled }
                    ]
                },
            ]
        }

        if (isExport) {
            return <TableRowExport {...objRenderData} />
        }

        return (
            <TableRowCommon
                {...objRenderData}
                onedit={() => onEdit(objRenderData.obj)}
                ondelete={() => handleSubmitModal(Number(objRenderData.id), 'DELETED', objRenderData.obj)}
                onactive={() => handleSubmitModal(Number(objRenderData.id), 'ACTIVE', objRenderData.obj)}
                oninactive={() => handleSubmitModal(Number(objRenderData.id), 'INACTIVE', objRenderData.obj)}
            />
        )
    }

    const handleSubmitModal = (id: number, status: string, obj?: any) => {
        setStatusAlertModal(status)
        setId(id)
        setIsOpenAlertModal(true)
        setName(obj.productWarningName)
        setNameEn(obj.productWarningNameEn)
    }

    return (
        <Box>
            <AlertModal
                isOpen={isOpenAlertModal}
                title={t(`MEDICINE_WARNING.ALERT.${statusAlertModal === 'DELETED' ? 'TITLE_DELETE' : 'TITLE_ACTIVE'}`)}
                message={t(`MEDICINE_WARNING.ALERT.${statusAlertModal === 'DELETED' ? 'CONFIRM_DELETE_' : 'CONFIRM_STATUS'}`, { productWarningName: name, productWarningNameEn: nameEn && `(${nameEn})`, status: t(`MEDICINE_WARNING.ALERT.${statusAlertModal}`) })}
                type={statusAlertModal === 'DELETED' ? 'error' : 'warning'}
                handleClose={() => setIsOpenAlertModal(false)}
                onCancel={{ onClick: () => setIsOpenAlertModal(false), title: t('BUTTON.CANCEL') }}
                onSubmit={{ onClick: statusAlertModal === 'DELETED' ? onDelete : onActive, title: t('BUTTON.SUBMIT') }}
            />
            <SnackbarComponent
                onOpen={isOpenSnack}
                onClose={() => setIsOpenSnack(false)}
                label={labelSnack}
                type={typeSnack}
                transform={`translateX(calc(100vw - 100% - 32px)) translateY(calc(-100vh + 100% + ${window.innerHeight - 50}px))`}
                autoHideTime={3000}
            />
            <HeaderCard text={t('MEDICINE_WARNING.TITLE')} />
            <Box paddingX="24px" paddingTop="16px">
                <Grid container spacing="16px">
                    <Grid item xs={12} sm={6} md={3} xl={2}>
                        <TextInput
                            label={t('MEDICINE_WARNING.SEARCH')}
                            value={search}
                            onChange={(event) => {
                                setSearch(event.target.value)
                            }}
                            fullWidth
                            inputProps={{
                                endAdornment: (
                                    <InputAdornment position="end" >
                                        {!search ? <FontAwesomeIcon icon={faSearch} style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: 15 }} /> :
                                            <FontAwesomeIcon
                                                icon={faTimes}
                                                onClick={() => {
                                                    setSearch('');
                                                }}
                                                style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: 17, cursor: 'pointer' }} />}
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3} xl={2}>
                        <SelectInput
                            onChange={(event) => {
                                const value = event.target.value
                                if (value) {
                                    handleChangeStatus(value)
                                }
                            }}
                            options={[
                                { value: 'ALL', name: t('STATUS.ALL') },
                                { value: 'ACTIVE', name: t('STATUS.ACTIVE') },
                                { value: 'INACTIVE', name: t('STATUS.INACTIVE') }
                            ]}
                            label={t('STATUS.LABEL')}
                            value={status}
                            width="100%"
                        />
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} xl={8}>
                        <Box display={'flex'} justifyContent={'space-between'}>
                            <MainButton
                                title={t('INPUT.SEARCH')}
                                type='primary'
                                variant='contained'
                                style={{ width: '120px' }}
                                onClick={() => {
                                    setPage(1)
                                    loadData()
                                }} />

                            <MainButton
                                title={t('MEDICINE_WARNING.BUTTON.ADD')}
                                disabled={permissions.isCreate.disabled}
                                type='primary'
                                variant='contained'
                                onClick={() => setIsOpenPageModal(true)}
                                startIcon={<AddCircleIcon />}
                            />
                        </Box>
                    </Grid>
                </Grid>
                <Box paddingTop="24px">
                    <TableCustom
                        page={page}
                        pageLimit={pageLimit}
                        sortType={sortType}
                        sortBy={sortBy}
                        onSort={onRequestSort}
                        setPageLimit={handleChangeRowsPerPage}
                        setPage={handleChangePage}
                        rowCount={rowCount}
                        headCells={headCells}
                        rowsData={productWarnigs.map((val, i) => {
                            return renderData(val, i)
                        })}
                    />
                </Box>
                <PageModal
                    isOpen={isOpenPageModal}
                    title={productWarnigId ? t('MEDICINE_WARNING.TITLE_UPDATE') : t('MEDICINE_WARNING.TITLE_CREATE')}
                    size='XS'
                    handleClose={resetForm}
                    onCancel={{ onClick: resetForm, title: t('MEDICINE_WARNING.BUTTON.CANCEL') }}
                    onSubmit={{ onClick: productWarnigId ? submitEdit : submit, title: t('MEDICINE_WARNING.BUTTON.SAVE'), disabled: disabledSubmit }}
                >
                    <Box display="flex" flexDirection="column">
                        {productWarnigId ? <Box display="flex" justifyContent="space-between" alignItems="center">
                            <Typography>{t('INPUT.LABEL_STATUS')}</Typography>
                            <SwitchButton onChange={() => setProductWarnigStatus(productWarnigStatus === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE')} checked={productWarnigStatus === 'ACTIVE' ? true : false} />
                        </Box> : ''}
                        <Box sx={{ fontWeight: 400, fontSize: '10px', color: '#808080', textAlign: 'end', marginLeft: '10px' }}>{`${textLength}/${40}`}</Box>
                        <TextInput
                            onChange={(event) => {
                                handleChangeName(event.target.value)
                                clearErrorMessage()
                            }}
                            value={productWarnigName}
                            label={t('MEDICINE_WARNING.INPUT.PRODUCT_WARNING_NAME')}
                            helperText={
                                errorMessage.PRODUCT_WARNING_NAME ||
                                errorMessage.IS_DUPLICATE_PRODUCT_WARNING_NAME ||
                                errorMessage.PRODUCT_WARNING_NAME_STRING_BASE ||
                                errorMessage.PRODUCT_WARNING_NAME_STRING_EMPTY ||
                                errorMessage.PRODUCT_WARNING_NAME_MAXIMUM_LENGTH ||
                                errorMessage.PRODUCT_WARNING_NAME_ANY_REQUIRED
                            }
                            required
                        />
                        <Box sx={{ fontWeight: 400, fontSize: '10px', color: '#808080', textAlign: 'end', marginLeft: '10px', marginTop: '24px' }}>{`${textLengthEn}/${40}`}</Box>
                        <TextInput
                            onChange={(event) => {
                                handleChangeNameEn(event.target.value)
                                clearErrorMessage()
                            }}
                            value={productWarnigNameEn}
                            helperText={
                                errorMessage.PRODUCT_WARNING_NAME_EN ||
                                errorMessage.IS_DUPLICATE_PRODUCT_WARNING_NAME_EN ||
                                errorMessage.PRODUCT_WARNING_NAME_EN_STRING_BASE ||
                                errorMessage.PRODUCT_WARNING_NAME_EN_STRING_EMPTY ||
                                errorMessage.PRODUCT_WARNING_NAME_EN_MAXIMUM_LENGTH ||
                                errorMessage.PRODUCT_WARNING_NAME_EN_ANY_REQUIRED
                            }
                            label={t('MEDICINE_WARNING.INPUT.PRODUCT_WARNING_NAME_EN')}
                        />
                    </Box>
                </PageModal>
            </Box>
        </Box>
    )
}
